import './ui.css';

export const BtnLoading = loading =>{
    return ( 
    <button className="btn btn-primary btn-block btn-lg login-btn" type="button" disabled>
    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    {' '+loading}...
  </button>
  )
}